var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.topbar},[_c('div',{staticClass:"mr-md-4 mr-auto"}),_c('div',{staticClass:"mr-auto d-none d-md-block"}),_c('div',{staticClass:"mr-4 d-none d-sm-block"},[_c('air-language-switcher')],1),_c('div',{},[_c('air-user-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }